import script from "./PopupWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupWindow.vue?vue&type=script&setup=true&lang=ts"

import "./PopupWindow.vue?vue&type=style&index=0&id=62a594dd&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a594dd"]])

export default __exports__